import { useCallback, useContext, useMemo } from 'react';

import withoutNulls from 'api/expression/withoutNulls';
import AccountPickerContext from 'contexts/AccountPickerContext';
import ReportContext from 'contexts/ReportContext';
import STORE from 'store';

import { FilterBarSettings } from './filterBarSettings';

// The report's quick filter and pinned filter settings, saved on the report
const useReportFilterBarSettings = (): FilterBarSettings => {
  const { selectedAccountId } = useContext(AccountPickerContext);
  const { report, quickFilters } = useContext(ReportContext);

  const save = useCallback(
    async (patch: {
      quickFilterOrder?: string[];
      pinnedFilterFields?: ReportPinnedFilters.Field[];
    }) => {
      if (!report) {
        return;
      }

      const newReport: ReportType = { ...report, ...patch };
      await STORE.getReportsRef({ accountId: selectedAccountId })
        .doc(report.id)
        .set(withoutNulls(newReport));
    },
    [report, selectedAccountId],
  );

  return useMemo(
    () => ({
      quickFilterSource: report ? `report: ${report.id}` : '',
      quickFilters,
      quickFilterOrder: report?.quickFilterOrder || window.emptyArray,
      pinnedFilterFields: report?.pinnedFilterFields || window.emptyArray,
      save,
    }),
    [quickFilters, report, save],
  );
};

export default useReportFilterBarSettings;
